import { Button, Grid, Paper, Typography } from "@material-ui/core";
import { Calendar } from "@material-ui/pickers";
import { TabPanel, TabPanelProps } from "./";
import { Dispatch, SetStateAction } from "react";
import { makeStyles } from "@material-ui/styles";

type Props = {
  calendarType: "date" | "year";
  setCalendarType: Dispatch<SetStateAction<"date" | "year">>;
  date: Date;
  setDate: Dispatch<SetStateAction<Date>>;
  currentTab: TabPanelProps["value"];
};

const YEARS = Array.from({ length: 2051 - 1980 }, (_, index) => 1980 + index);

const dateTabStyles = makeStyles({
  container: ((calendarType) => ({
    width: "100%",
    height: 305,
    overflowY: calendarType === "year" ? "scroll" : "auto",
  }))(),
});

export const DateTab = ({
  currentTab,
  setDate,
  date,
  calendarType,
  setCalendarType,
}: Props) => {
  const classes = dateTabStyles("blue");

  const calendarChangeHandler = (date: any) => {
    if (!date) return;
    setDate((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(date.getDate());
      newDate.setMonth(date.getMonth());
      return newDate;
    });
  };

  const yearChangeHandler = (year: number) => {
    setDate((prev) => {
      const newDate = new Date(prev);
      newDate.setFullYear(year);
      return newDate;
    });
    setCalendarType("date");
  };

  return (
    <TabPanel value={currentTab} index={0}>
      <Paper className={classes.container}>
        {calendarType === "date" ? (
          <Calendar date={date} onChange={calendarChangeHandler} />
        ) : (
          <Grid container direction="column">
            {YEARS.map((year) => (
              <Grid item key={year}>
                <Button fullWidth onClick={() => yearChangeHandler(year)}>
                  <Typography variant="subtitle1">{year}</Typography>
                </Button>
              </Grid>
            ))}
          </Grid>
        )}
      </Paper>
    </TabPanel>
  );
};
